import { Tabs } from '@mantine/core';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { adminPageOf } from './admin-sections';

/**
 * Вкладки раздела администрирования над страницей.
 *
 * Это обёртка-маршрут, а не правка каждой страницы: страницы остались
 * прежними, со своими адресами и заголовками. Раздел из одной страницы
 * вкладок не получает — одна вкладка ничего не выбирает.
 *
 * Вкладка ведёт на адрес страницы, поэтому из редактора колоды вкладка
 * «Колоды» возвращает к списку, хотя она и так подсвечена. Стрелки только
 * переводят фокус: переход по каждому нажатию стрелки открывал бы страницы,
 * которые человек просто пролистывает.
 */
export function AdminSectionLayout() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const current = adminPageOf(pathname);

  return (
    <>
      {current && current.section.pages.length > 1 ? (
        <Tabs value={current.page.to} activateTabWithKeyboard={false} mb="lg" data-testid="admin-section-tabs">
          <Tabs.List aria-label={current.section.label}>
            {current.section.pages.map((page) => (
              <Tabs.Tab
                key={page.to}
                value={page.to}
                onClick={() => {
                  if (pathname !== page.to) void navigate(page.to);
                }}
              >
                {page.label}
              </Tabs.Tab>
            ))}
          </Tabs.List>
        </Tabs>
      ) : null}
      <Outlet />
    </>
  );
}
